import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

import { Action } from "vuex-class";
const namespace: string = "profile";

import { bootbox } from "../../infrastructure/bootbox-shim";
import { ClientNotifier } from "../../scripts/ah.mb.client-notifications";
import { ModelNotifier } from "../../scripts/model-notifier";
import { ReportServices } from "../../scripts/ah.mb.report-services";
import { modelServices } from "../../scripts/ah.mb.ui.model-services";
import { Clipboard } from "../../scripts/ah.mb.clipboard";
import { DefaultModelActionsHandler } from "../../scripts/model-notifier/ah.mb.common.default-model-actions-handler";
import { DefaultLinkRules } from "../../scripts/ah.mb.default-link-rules";
import { LinkValidator } from "../../scripts/ah.mb.link-validator";
import { ModelUtils } from "../../scripts/ah.mb.ui.model-utils";
import { ModelTree } from "../../scripts/ah.mb.model-tree";
import { GoogleChartRenderer } from "../../scripts/ah.mb.googleChartRenderer";
import { PageType, RecentlyVisitedPages } from "../../scripts/common/ah.mb.common.stored-stack";
import { IEditReportFolderModel, IReportParams } from "../../entities/edit-report-model";
import { NodeObject } from "../../scripts/common/ah.mb.common.node-object";
import { IDownloadReportsModel } from "../../entities/download-reports-model";
import { ReportConfiguration } from "../../entities/edit-report-model";
import { IModelActionsHandler }from "../../scripts/model-notifier/ah.mb.common.model-actions-handler";
import { IReportEditorConfig } from "../report-editor-dialog/report-editor-dialog";
import { IDashboardPublishDefinition } from "../../scripts/dashboardServices";
import * as d3 from "d3";

class ReportNode extends NodeObject {
    reportParams: IReportParams;
}

@Component
export default class ModelReports extends Vue {

    @Action("setCurrentModelId", { namespace: namespace }) setCurrentModelId: any;

    //private WIDTH = 0;
    //private HEIGHT = 0;
// Setup height and width

//var offsets = document.getElementById('reportListDiv').getBoundingClientRect();
//var notificationRect = 0;


    created() {
    }

    @Prop()
    modelId: string;

    showPublishToDashboardDialog: boolean = false;
    publishToDashboardModel: IDashboardPublishDefinition = {
        name: "", modelId: "", exports: [], customFieldDefs: [],/*nodePathAndName: "", format: "JSON", query: "", resultType: "Report Results",*/
        setName: ""
    }; 


// Create user notifier
    private userNotifier = new ClientNotifier();


// Model change observer
    private modelObserver = new ModelNotifier();

// Create scriptServices
//var scriptServices = scriptServices;
    reportServices = new ReportServices(this.modelObserver);

// Create modelservicesi
    modelServices = new modelServices(this.modelObserver);

// Model tree clipboard
    private clipboard = new Clipboard();

// Model actions handler
    private modelActionsHandler: IModelActionsHandler;

    private isLoading: boolean = false;


    private modelTree = null;

// Model tree clipboard
// Get rid of the above one in favor of this eventually

    showReportEditor: boolean = false;
    editReportModel: IReportEditorConfig = {
        modelId: "",
        reportName: "",
        mode: "edit",
        reportNodePath: "",
        reportNodePathAndName: "",
        reportParams:
        {
            sector: "",
            direction: "",
            resultType: "",
            nodeTypes: [],
            queryString: "",
            nodeTags: [],
            excludeNodeTags:[],
            configuration: [],
            requiredFilters: [],
            isGeographic: false,
            includeAllScenarios: false,
            scenarioNames: []
        },
        modelInfo: null

//        originalName: ""
    }


    showReportFolderEditor: boolean = false;
    editReportFolderModel: IEditReportFolderModel = {modelId:"",name:"",path:"",nodePathAndName:"",mode:"create"};

    downloadReportsModel: IDownloadReportsModel =
        {
            mode: "byReportDefinition", modelId: "", createPivots: false, format: "excel", reportNodePathAndNames: [], singleSheet: false,
            recursive: false,
            reportNames: []
    }
    showDownloadReportsDialog: boolean = false;

    forceViewTypeId: string = "-1";

    /**
 * Update if model param in route changed
 * @param oldVal
 * @param newVal
 */
    @Watch("$route.params.modelId")
    routeModeIdChanged(newVal) {
        this.loadModel();

    }


    /**
     * Before route leave handler
     * @param from
     * @param to
     * @param next
     */
    beforeRouteLeave(from, to, next) {
        // Detatch paste handler so it doesn't get fired after we have left this page
        document.removeEventListener("paste", this.documentPasteHandler);
        next();
    }


    loadModel() {
        this.setCurrentModelId(this.modelId);

        // Add page to recent list
        if (this.modelId) {
            const recentItemsStore = new RecentlyVisitedPages(8);
            recentItemsStore.stack.add(
                {
                    modelId: this.modelId,
                    pageType: PageType.Reports,
                    name: this.modelId + " | Reports",
                    visitedDate: new Date()
                });
        };

        this.modelActionsHandler = new DefaultModelActionsHandler(
            this.modelId,
            this.modelServices,
            this.userNotifier,
            this.clipboard);

        // Attach paste handler
        document.addEventListener("paste", this.documentPasteHandler);

        this.populateTree();


    }

    pasteButtonClick() {
        /* IE only fucking bs to fix non-pasting to tree problem */
        const clipboarddata = (window as any).clipboardData.getData("Text");
        this.pasteNodesFromClipboard(clipboarddata);

    }

    showAsTableCheckboxClick() {
        this.drawChart([this.modelTree.getActiveNode()]);
    }

    mounted() {


        $("#pageHeader").text(this.modelId + " Reports: (no report selected)");


        // There is no paste button (has to be by user action)
        //$('#pasteToTreButton').click(pasteToTreeButtonClick);


        $("#loader").hide();

        // Setup tooltips
        $("body")
            .tooltip({
                selector: "[title]",
                delay: { show: 500, hide: 500 }
            });
        //$('[title]').tooltip();

        // The paste button is only needed for IE
        if ((window as any).clipboardData == undefined)
            $("#pasteButton").hide();


//        this.setControlSizes();


        if (!this.modelId) {
            bootbox.alert("No model selected.  You will now be redirected to the model index page",
                () => {
                    this.$router.push({ name: "model-directory" });

                });

        }
        else
            this.loadModel();


    }

    onReportEditorClosed(result: string) {
        this.showReportEditor = false;
        if (result === "ok")
            this.drawChart([this.modelTree.getActiveNode()]);

    }

// Populate tree function
    populateTree() {

        const getNodesUrlFunc = (modelId, nodePathAndName) => "/api/1.0/reports/" + modelId + "/reporttree?rootNode=" + nodePathAndName;

        // Create a root tree node
        const rootTreeNode = {
            title: "Reports",
            key: "\\Reports",
            lazy: true,
            extraClasses: "reportfolder-node fancytree-has-children",
            folder: true,
            nodeType: "ReportFolder"
        };

        // Client-side logic
        // Awkward composition here
        const linkRules = DefaultLinkRules.getRules();
        const linkValidation = new LinkValidator(linkRules);
        const modelUtils = new ModelUtils(linkValidation);

        this.modelTree = new ModelTree($("#reportTreeDiv"),
            getNodesUrlFunc,
            this.modelId,
            rootTreeNode,
            this.treeSelectionChanged,
            this.modelActionsHandler,
            this.treeNodeIconClicked,
            //editNodePropertiesButtonClick,
            modelUtils);

        this.modelObserver.attach(this.modelTree);
    }


// Tree node icon click event
    treeNodeIconClicked(nodeObject) {
        this.showNodePropertiesDialog(nodeObject);
        // Return continueProcessing as false
        return false;
    }


    onReportFolderDialogClosed() {
        this.showReportFolderEditor = false;
    }

// Shows script editor
    showScriptEditorDialog(model: IEditReportFolderModel) {
        this.editReportFolderModel = model;
        this.showReportFolderEditor = true;
    }

// Add script button click handler
    addScriptButtonClick() {

        const selectedNode = this.modelTree.getActiveNode();
        this.showScriptEditorDialog({
            mode: "create",
            modelId: this.modelId,
            path: selectedNode.pathAndName,
            name: "New Folder",
            nodePathAndName: ""
        });

    }

    // Shows report editor for new or edit purposes
    showReportEditorDlg(model: IReportEditorConfig) {
        this.editReportModel = model;
        this.showReportEditor = true;
    }

// Add report button click handler
    addReportButtonClick() {

        const selectedNode = this.modelTree.getActiveNode();

        var config: ReportConfiguration = {};
        config["tagAndOr"] = "and";

        // Setup model info (required for scenario chooser)
        // Load view for node into the tree
        this.modelServices.getModelInfo(this.modelId)
            .then(info => {

                this.showReportEditorDlg({
                    mode: "create",
                    modelId: this.modelId,
                    reportNodePathAndName: "",
                    reportNodePath: selectedNode.pathAndName,
                    reportName: "",
                    reportParams:
                    {
                        sector: "",
                        direction: "Input",
                        resultType: "Quantity",
                        nodeTypes: [],
                        queryString: "",
                        nodeTags: [],
                        excludeNodeTags: [],
                        configuration: config,
                        requiredFilters: [],
                        isGeographic: false,
                        includeAllScenarios: false,
                        scenarioNames: []
                    },
                    modelInfo: info

                });
            });

    }

    updateActions(selection: NodeObject[]) {

        const noneSelected = selection.length === 0;
        const anySelected = selection.length > 0;
        const oneSelected = selection.length === 1;

        const folderSelected = oneSelected ? selection[0].nodeType === "ReportFolder" : false;

        const rootSelected = $.grep(selection,
                node => node.pathAndName === "\\Reports").length >
            0;

        $("#deleteSectorButton").toggleClass("disabled", !anySelected || rootSelected);
        $("#addSectorButton").toggleClass("disabled", !folderSelected);
        $("#renameSectorButton").toggleClass("disabled", rootSelected || !oneSelected);


        $("#deleteSectorButton").toggleClass("disabled", rootSelected || !anySelected);
        $("#addReportButton").toggleClass("disabled", !folderSelected);

        $("#downloadReportsAsExcelButton").toggleClass("disabled", noneSelected);

        // Search and replace button enabled/disabled
        $("#searchAndReplaceButton").toggleClass("disabled", !anySelected);

        // Cut/copy/paste buttons
        $("#cutSelectedTreeNodesButton").toggleClass("disabled", !anySelected);
        $("#copySelectedTreeNodesButton").toggleClass("disabled", !anySelected);

        $("#copyButton").toggleClass("disabled", !anySelected);
        $("#pasteButton").toggleClass("disabled", !anySelected);

        //$('#pasteToTreeButton').toggleClass('disabled', !anySelected);

        // Enable/disable nav buttons
        //$('#treeBackButton').toggleClass('disabled', !navStack.canGoBack());
        //$('#treeBackButton').attr("title", 'Back to ' + navStack.backName());
        //$('#treeForwardButton').toggleClass('disabled', !navStack.canGoForward());
        //$('#treeForwardButton').attr("title", 'Forward to ' + navStack.forwardName());

    }

// Draws the chart for a report
    drawChart(reports: NodeObject[]) {



        if (reports.length > 1)
            return;

        d3.selectAll("svg > *").remove();

        // Force chart tooltips destruction
        // Bug in nvd3 requires this
        d3.selectAll(".nvtooltip").style("opacity", "0");
        $(".d3-tip").remove();
        $(".nvtooltip").remove();

        if (reports.length === 0) {
                $("#pageHeader").text(this.modelId + " Reports: " + "(no report selected)");

        } else if (reports.length === 1 && reports[0].nodeType === "Report") {
            //$('#chartDiv').hide();
            //$("#loader").show();

            // Exclude auto reports and those with no node selected because they are too big
            var autoReports = (reports.find(p => p.path.startsWith('\\Reports\\_Auto')));
            if (autoReports)
            {
                    $("#pageHeader").html(this.modelId +
                        " Reports: Cannot display automatic reports");
                return;
            }

            this.isLoading = true;

            this.reportServices.getReportData(this.modelId,
                "googleCharts",
                [reports[0].pathAndName],
                reportResults => {

                    // Chart renderer
                    var chartRenderer =
                        //    new AH.MB.UI.Nvd3ChartViewRenderer();
                        new GoogleChartRenderer();

                    chartRenderer.forceViewType(parseInt(this.forceViewTypeId)); // 4 = table

                    chartRenderer.drawGraph($("#chartContainerDiv"), // Nvd3: $('#chartDiv svg')
                        reportResults,
                        {
                            showLegend: true,
                            showTitle: false,
                            showXAxisTitlesFunc: () => true,
                            showYAxisTitlesFunc: () => true,
                            backgroundColor: "white"
                        })
                        .then(() => {

                            //$("#loader").hide();
                            this.isLoading = false;

                        });

                    $("#pageHeader").html(this.modelId +
                        " Reports: " +
                        reportResults.title +
                        "<small> " +
                        reportResults.subTitle +
                        "</small>");
                    //$("#pageHeader").text(reportResults.subTitle);

                });
        }

    }

// Handles a change in selection
    treeSelectionChanged(reports: NodeObject[]) {

        this.updateActions(reports);
        this.drawChart(reports);

    }

    showNodePropertiesDialog(selectedNode) {

        switch (selectedNode.nodeType) {
        case "ReportFolder":
            this.modelServices.getNodeDataValue(this.modelId,
                    selectedNode.pathAndName,
                    "MasterNodePathAndName")
                .then(
                    data => {
                        this.showScriptEditorDialog({
                            mode: "edit",
                            modelId: this.modelId,
                            path: selectedNode.pathAndName,
                            name: selectedNode.name,
                            nodePathAndName: data
                        });
                    });
            break;

        case "Report":

            this.reportServices.getReportParams(this.modelId, selectedNode.pathAndName)
                .then(params => 
                {
                    this.modelServices.getModelInfo(this.modelId)
                        .then(info => {

                            // Ensure non-null for legacy reports
                            params.nodeTypes = params.nodeTypes || [];
                            params.queryString = params.queryString || "";

                            var model: IReportEditorConfig = {
                                mode: "edit",
                                modelId: this.modelId,
                                reportNodePath: selectedNode.path,
                                reportNodePathAndName: selectedNode.pathAndName,
                                reportName: selectedNode.name,
                                reportParams: params,
                                modelInfo: info
                            };

                            // New model function
                            // Export results data button click handler
                            this.showReportEditorDlg(model);
                        });
                });

        }

    }

    getActiveNodeType(): string {
        const node = this.getActiveNode();
        if (node && node.isFolder)
            return "Folder";
        return "Report";

    }

    getActiveNodeName(): string {
        const node = this.getActiveNode();
        if (node)
            return node.name;
        return "";
    }

    getActiveNode(): NodeObject {
        if (this.modelTree)
            return this.modelTree.getActiveNode();
        return null;
    }


    // Rename sector button click handler
    renameNodeButtonClick() {
        const activeNode = this.modelTree.getActiveNode();
        if (activeNode)
            this.modelActionsHandler.renameNode(activeNode.pathAndName);
    }


// Edit selected node properties button lick
    editNodePropertiesButtonClick() {
        const selectedNode = this.modelTree.getActiveNode();
        this.showNodePropertiesDialog(selectedNode);
    }

// Delete node button click
    deleteSelectionButtonClick() {

        const nodes = this.modelTree.getSelectedNodes();
        this.modelActionsHandler.deleteNodes(nodes);
    }


// Download as excel fun
    downloadSelectedReportsAsExcelClick() {

        const selection: NodeObject[] = this.modelTree.getSelectedNodes();
        const reportIds = $.map(selection, n => n.pathAndName);

        this.downloadReportsModel = {
            mode: "byReportDefinition", 
            modelId: this.modelId,
            singleSheet: false,
            format: "excel",
            reportNodePathAndNames: reportIds,
            createPivots: false,
            reportNames: [],
            recursive: false
        }
        this.showDownloadReportsDialog = true;
    };

    onDownloadReportsDialogClosed() {
        this.showDownloadReportsDialog = false;
    }

    scrollTreeToTopButtonClick() {
        this.modelTree.scrollToTop();
    }

    treeFilterInputBoxKeyUp(e) {
        const filter = $("#treeFilterInputBox").val();
        this.modelTree.applyFilter(filter);
    }


// Note this button doesnt't exist for now
    clearTreeFilterBtnClick() {
        $("#treeFilterInputBox").val("");
        this.modelTree.applyFilter("");

    }

// Document paste handler
    documentPasteHandler(e) {

        if ($(e.currentTarget.activeElement).hasClass("fancytree-container")) {
            e.preventDefault();

            const text = (e.originalEvent || e).clipboardData.getData("text/plain");
            if (!text) {
                alert("Error getting clipboard data");
                return;
            }

            // Now paste
            this.pasteNodesFromClipboard(text);
        }
        // If we dont have the focus, let the event continue propogation
    }

/**
* Pastes nodes from clipboard
*/
    pasteNodesFromClipboard(clipboardText) {

        const targetNode = this.modelTree.getActiveNode();

        if (targetNode) {

            let targetPath = targetNode.pathAndName;

            // We can't paste to a leaf node,
            if (targetNode.nodeType === "Report") {
                targetPath = targetNode.path;
            }


            this.modelActionsHandler.pasteNodesFromClipboard(targetPath, clipboardText, []);

        } else
            bootbox.alert("No target tree node selected");
    }

// Copies selected tree nodes
    cutSelectedTreeNodesButtonClick() {
        this.modelTree.copySelectedTreeNodes(true);
    }

// Copies selected tree nodes
    copySelectedTreeNodesButtonClick() {

        this.modelTree.copySelectedTreeNodes(false);
    }


/* Set element sizes for ones where we can't get the fuckin css to do it for us
This is called on resize, and also after adminlte sidebar collapse/expand */
    setControlSizes() {

        const parent = $(".content-wrapper");

        const tree = $("#reportTreeDiv");
        const footer = $("footer");

        const buttonsRow = $("#treeButtonsDiv");

        const mainHeader = $(".main-header");
        const header = $(".content-header");

        const margins = 12;

        const windowHeight = window.innerHeight;

        const treeHeight = windowHeight -
            footer.outerHeight() -
            buttonsRow.outerHeight() -
            24 -
//            header.outerHeight() -
            mainHeader.outerHeight();

        //console.clear();
        //console.log('windowHeight', windowHeight);

        //console.log('buttonsRow.height()', buttonsRow.height());
        //console.log('$(window).height()', $(window).height());
        //console.log('footer.outerHeight()', footer.outerHeight());

        //console.log('parent.outerHeight()', parent.outerHeight());
        //console.log('parent.height()', parent.height());
        //console.log('mainHeader.outerHeight', mainHeader.outerHeight());
        //console.log('header.outerHeight()', header.outerHeight());
        //console.log('buttonsRow.outerHeight()', buttonsRow.outerHeight());

        //console.log('treeHeight', treeHeight);

        const viewDiv = $("#viewDiv");

        //console.log('*** WIDTHS ***');
        //console.log('parent.outerWidth()', parent.outerWidth());
        //console.log('viewDiv.outerWidth()', viewDiv.outerWidth());

        tree.height(treeHeight - (margins));
        tree.width(parent.outerWidth() - viewDiv.outerWidth() - (margins));

        const chartDiv = $("#chartDiv");
        chartDiv.width(viewDiv.width());

        chartDiv.height(tree.height());
    }

    restoreAutomaticReportsClick() {
        bootbox.confirm("Restore automatic reports?  This will undo any customizations to automatic reports, and restore deleted ones",
            ok => {
                if (ok)
                    this.reportServices.restoreAutomaticReports(this.modelId)
                        .then(response => {
                            if (response.success)
                                this.populateTree();
                        });
            });
    }

    publishToDashboard() {
        const targetNode = this.modelTree.getActiveNode();

        this.publishToDashboardModel = {
            //format: "JSON",
            //nodePathAndName: targetNode.pathAndName, // Todo: Check this
            //query: "", // Indicates all reports for the node
            name: "",
            modelId: this.modelId,
            setName: "",
            exports: [],
            customFieldDefs: []
            //resultType: "Report Results"
        }
        this.showPublishToDashboardDialog = true;
    }

    onPublishToDashboardDialogClosed() {
        this.showPublishToDashboardDialog = false;
    }

    @Watch("forceViewTypeId")
    forceViewTypeIdChanged(newVal) {
        this.drawChart([this.modelTree.getActiveNode()]);

    }


}







// WEBPACK FOOTER //
// ./ClientApp/components/model-reports/model-reports.ts